import styled from 'styled-components';

import { theme } from '../layout/theme';
import { size } from '../layout/helpers';

export const Price = styled.div`
  font-weight: 700;
  line-height: 1.2;
  font-size: 1rem;
  margin-right: 8px;

  ${theme.screens.Sm} {
    font-size: 1.25rem;
    letter-spacing: -0.02em;
  }

  &.sale {
    color: ${theme.colors.text.highlight};
  }

  &.inline {
    display: inline-block;
  }

  &.large {
    font-size: 1.25rem;

    ${theme.screens.Sm} {
      font-size: 1.5rem;
    }
  }
`;

export const PriceDesign = styled.div<IPriceDesign>`
  font-weight: 700;
  line-height: 1.2;
  font-size: 1.5rem;
  letter-spacing: -0.02em;
  border-radius: 6px;
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.textColor};
  padding: 2px 8px;
  display: inline-flex;

  &.product-page {
    line-height: 1.2;
    font-size: 1rem;

    ${theme.screens.SmLtMd} {
      font-size: 2rem;
    }

    ${theme.screens.LtSm} {
      font-size: 1.5rem;
      letter-spacing: -0.02em;
    }

    ${theme.screens.Sm} {
      font-size: 1.5rem;
      letter-spacing: -0.02em;
    }

    &.large {
      font-size: 1.25rem;

      ${theme.screens.Sm} {
        font-size: 2rem;
      }
    }
  }

  ${theme.screens.LtSm} {
    font-size: 16px;
  }

  &.large {
    font-size: 1.25rem;

    ${theme.screens.Sm} {
      font-size: 2rem;
    }
  }
`;

export const OldPrice = styled.div`
  font-weight: 400;
  line-height: 1.2;
  font-size: 0.875rem;
  margin-top: ${size(0.25)};
  color: ${theme.colors.text.alt};

  &.inline {
    display: inline-block;
  }

  ${theme.screens.Sm} {
    font-size: 1rem;
    letter-spacing: -0.02em;
  }

  &.large {
    ${theme.screens.Sm} {
      font-size: 1.125rem;
    }
  }
`;

export const PilPriceWrapper = styled.div`
  margin-top: 2px;
  display: flex;
  align-items: center;
`;

export const PilPriceText = styled.div`
  font-weight: 400;
  line-height: 20px;
  font-size: 0.875rem;
  color: ${theme.colors.text.alt};

  ${theme.screens.Sm} {
    font-size: 1rem;
    letter-spacing: -0.02em;
  }

  &.large {
    ${theme.screens.Sm} {
      font-size: 1.125rem;
    }
  }
`;
